<template>
  <div class="popup" v-if="halloweenSaleShow" v-cloak>
       <div class="halloweenSaled-content"  id='halloweenSaled' :class="[user.vip?'blackFridaySaled_two':'blackFridaySaled_one',user.payType=='Yearly'&&user.vip?'blackFridaySaled_three':'']">
            <div class="blackFridaySaled-close" @click="closePage()"></div>
            <div class="blackFridaySaled_title">
                 <div  :class="user.payType=='Yearly'&&user.vip?'blackFridaySaled_txt_more':'blackFridaySaled_txt'">

                 </div>
            </div>
            <div class="blackFridaySaled_title">
                 <div :class="user.payType=='Yearly'&&user.vip?'blackFriday_special_two':'blackFriday_special_one'">
                  <div class="blackFriday-last-tip">
                     <span>{{$t('language.balackFriday.lastTip')}}</span>
                  </div>
                 </div>
            </div>
                <div class="blackFridaySaled_product">
                    <div  :class="user.vip?'product_two':'product_all'">
                    <div class="product_one" v-for="(item, index) in showData" :key="index">
                         <div class="product_name">
                             {{item.name}}
                         </div>
                         <div class="product_img" >
                              <div :class="index==0 && user.payType!='Yearly'?'blackFriday-discount2':'blackFriday-discount1'">
                                 <div class="product-txt">{{item.discount}}</div>
                                 <div class="product-txt" style="font-size:18Px">Off</div>
                              </div>
                         </div>
                         <div class="product_descri_all" >
                         <div class="product_descri" v-html="item.describe">
                             
                         </div>
                         </div>
                         <div class="product_descri_all" style="height:50Px;">
                            <div style="margin:0 auto;">
                             <div class="product_price">
                                {{item.price}}
                            </div>
                             <div class="product_oldprice">
                                {{item.oldPrice}}
                            </div>
                            </div>
                         </div>
                         <div class="product_descri_all">
                               <div v-loading='item.loading' class="blackFriday-price-btn" :class="[index==0 && user.payType!='Yearly'?'blackFriday-price-btn-2':'blackFriday-price-btn-1',item.loading?'item-onlyRead':'']" @click="upgrade(item)">
                                       {{$t('language.common.upgradeNow')}}
                               </div>
                         </div>
                        
                    </div>
                   
                   
                    </div>
                  
                </div> 
                
       </div>
       
  </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
import paySysUtils from "@/js/workspace/pay_system_util.js";
import upgradeItemUtils from '@/js/workspace/upgrade_item.js';
export default {
 data:function(){
     return{
       halloweenSaleShow:false,
       user:null,
       showData:[],
       products:[{
           name:this.$t('language.paySystem.monthly'),
           discount:'20%',
           describe:this.$t('language.popup.salePagePopup.premiumFeatures'), 
           price:'$7.9',
           oldPrice:'$9.9',
           productId:'215655',
           coupon:'NJF-SG7-A3L',
           xPage:"BF2021-pop-up",
           payLevel:2,
           xMb:14,//退款天数
       },{
            name:this.$t('language.paySystem.YearlyUnlimited'),
             discount:'30%',
             describe:this.$t('language.popup.salePagePopup.unlimitedYear'), 
             price:'$79.9',
             oldPrice:'$119.9',
             productId:'236257',
             coupon:'4JU-XZB-DPE',
             xPage:"BF2021-pop-up",
             payLevel:1,
             xMb:30,//退款天数
       },{
            name:this.$t('language.rightTopBanner.lifeTimePlan'), 
            discount:'55%',
            describe:this.$t('language.popup.salePagePopup.unlimitedLiftime'), 
            price:'$179.9',
            oldPrice:'$399.0',
            productId:'235802',
            xMb:30,//退款天数
            xPage:'BF2021-pop-up',
            coupon:'BQJ-6DF-51F',
            payLevel:1,
       }
       ],
       productsTwo:[{
            name:this.$t('language.paySystem.YearlyUnlimited'),
             discount:'25%',
             describe:this.$t('language.popup.salePagePopup.unlimitedYear'), 
             price:'$79.9',
             oldPrice:'$119.9',
              productId:'236257',
            xMb:30,//退款天数
            xPage:'BF2021-pop-up',
            coupon:'GMQ-H9V-649',
            payLevel:1,

       },{
            name:this.$t('language.rightTopBanner.lifeTimePlan'), 
            discount:'55%',
            describe:this.$t('language.popup.salePagePopup.unlimitedLiftime'), 
            price:'$179.9',
            oldPrice:'$399.0',
            productId:'235802',
            xMb:30,//退款天数
            xPage:'BF2021-pop-up',
            coupon:'BQJ-6DF-51F',
            payLevel:1,
       }],
       otherOne:[{
            name:this.$t('language.rightTopBanner.lifeTimePlan'), 
            discount:'75%',
            describe:this.$t('language.popup.salePagePopup.unlimitedLiftime'), 
            price:'$89.9',
            oldPrice:'$399.0',
            productId:'235802',
            xMb:30,//退款天数
            xPage:'BF2021-pop-up',
            coupon:'JMX-YGF-2U6',
            payLevel:1,
       }],
       notifyShow:false,
       requestNum:0
     }
 },
 watch:{
     halloweenSaleShow(newValue,oldValue){
         if(newValue){
           this.initData();
         }
     },
 },
 methods:{
     initData(){
        var that = this;
     this.user = commonUtils.getUser();
             let user = commonUtils.getUser();
             this.$i18n.locale = localStorage.getItem("locale") || 'english';
             this.casePrice(this.$i18n.locale);
             if(!user.vip){
                 this.showData = this.products;
                 return;
             }
             if(user.payType == 'Yearly'){//大于1为有限，如果为有限月，有限季用户或无限月
                 this.showData = this.otherOne;
                 return;
             }
              if(!localStorage.getItem(user.id+'oldPayMoney') || !localStorage.getItem(user.id+'hallonewPayMoney')){
                //判断用户是否是paypal用户
                var subscrId = user.subscrId.toString();
                if(subscrId != null && subscrId.indexOf("I")==0){//如果是paypal用户
                 this.productsTwo[0]={
             name:this.$t('language.paySystem.YearlyUnlimited'),
             discount:'25%',
             describe:this.$t('language.popup.salePagePopup.unlimitedYear'), 
             price:'$79.9',
             oldPrice:'$119.9',
             productId:'236257',
            xMb:30,//退款天数
            xPage:'BF2021-pop-up',
            coupon:'4JU-XZB-DPE',
            payLevel:1,
                 }
                this.casePrice(this.$i18n.locale);
                this.showData = this.productsTwo;
                return;
                }
               setTimeout(() => {
               that.initData();
               },100);
               return;
              }
              this.productsTwo[0].oldPrice=localStorage.getItem(user.id+'oldPayMoney');
              this.productsTwo[0].price=localStorage.getItem(user.id+'hallonewPayMoney');
              this.showData = this.productsTwo;
              return;
     },
     casePrice(language){
         if(language == 'english'){
            this.products[0].price = '$7.9';
            this.products[0].oldPrice = '$9.9';
            this.products[1].price = '$79.9';
            this.products[1].oldPrice = '$119.9';
            this.products[2].price = '$179.9';
            this.products[2].oldPrice = '$399.0';
            this.productsTwo[0].price = '$79.9';
            this.productsTwo[0].oldPrice = '$119.9';
            this.productsTwo[1].price = '$179.9';
            this.productsTwo[1].oldPrice = '$399.0';
            this.otherOne[0].price = '$89.9';
            this.otherOne[0].oldPrice = '$399.0';
         }
         if(language == 'portuguese'){
             this.products[0].price = 'R$43,99';
             this.products[0].oldPrice = 'R$53,99';
             this.products[1].price = 'R$439,99';
             this.products[1].oldPrice = 'R$659,99';
             this.products[2].price = 'R$949,99';
             this.products[2].oldPrice = 'R$2.099,99';
            this.productsTwo[0].price = 'R$439,99';
            this.productsTwo[0].oldPrice = 'R$659,99';
            this.productsTwo[1].price = 'R$949,99';
            this.productsTwo[1].oldPrice = 'R$2.099,99';
            this.otherOne[0].price = 'R$469,99';
            this.otherOne[0].oldPrice = 'R$2.099,99';
         }
         if(language =='deutsch' || language =='france' ||language =='spanish' || language =='italian'){
            this.products[0].price = '7,99€';
            this.products[0].oldPrice = '9,99€';
             this.products[1].price = '79,99€';
            this.products[1].oldPrice = '119,99€';
            this.products[2].price = '179,99€';
            this.products[2].oldPrice = '399,99€';
            this.productsTwo[0].price = '79,99€';
            this.productsTwo[0].oldPrice = '119,99€';
            this.productsTwo[1].price = '179,99€';
            this.productsTwo[1].oldPrice = '399,99€';
            this.otherOne[0].price = '89,99€';
            this.otherOne[0].oldPrice = '399,99€';

         }
         if(language == 'japanese'){
            this.products[0].price = '880円';
            this.products[0].oldPrice = '1,180円'; 
            this.products[1].price = '9,320円';
            this.products[1].oldPrice = '13,980円';
            this.products[2].price = '19,830円';
            this.products[2].oldPrice = '43,980円';
            this.productsTwo[0].price = '9,320円';
            this.productsTwo[0].oldPrice = '13,980円';
            this.productsTwo[1].price = '19,830円';
            this.productsTwo[1].oldPrice = '43,980円';
            this.otherOne[0].price = '9,880円';
            this.otherOne[0].oldPrice = '43,980円';
         }
         if(language == 'traditionalChinese'){
             this.products[0].price = 'NT$219';
             this.products[0].oldPrice = 'NT$299'; 
             this.products[1].price = 'NT$2,339';
             this.products[1].oldPrice = 'NT$3,499';
             this.products[2].price = 'NT$5,190';
             this.products[2].oldPrice = 'NT$11,499';
             this.productsTwo[0].price = 'NT$2,339';
             this.productsTwo[0].oldPrice = 'NT$3,499';
             this.productsTwo[1].price = 'NT$5,190';
             this.productsTwo[1].oldPrice = 'NT$11,499';
             this.otherOne[0].price = 'NT$2,599';
            this.otherOne[0].oldPrice = 'NT$11,499';
         }
         if(language == 'chinese'){
             this.products[0].price = '¥49';
             this.products[0].oldPrice ='¥59';
             this.products[1].price = '¥506';
             this.products[1].oldPrice = '¥759';
             this.products[2].price = '¥1,127';
             this.products[2].oldPrice = '¥2,499'; 
             this.productsTwo[0].price = '¥506';
             this.productsTwo[0].oldPrice = '¥759';
             this.productsTwo[1].price = '¥1,127';
             this.productsTwo[1].oldPrice = '¥2,499';
             this.otherOne[0].price = '¥569';
            this.otherOne[0].oldPrice = '¥2,499';
         }
         this.products[0].name = this.$t('language.paySystem.monthly');
         this.products[0].describe = this.$t('language.popup.salePagePopup.premiumFeatures');
         this.products[1].name = this.$t('language.paySystem.YearlyUnlimited');
         this.products[1].describe = this.$t('language.popup.salePagePopup.unlimitedYear');
         this.products[2].name = this.$t('language.rightTopBanner.lifeTimePlan');
         this.products[2].describe = this.$t('language.popup.salePagePopup.unlimitedLiftime');
         this.productsTwo[0].name =  this.products[1].name;
         this.productsTwo[0].describe =  this.products[1].describe;
         this.productsTwo[1].name = this.products[2].name;
         this.productsTwo[1].describe = this.products[2].describe;
         this.otherOne[0].name =  this.productsTwo[1].name;
         this.otherOne[0].describe = this.productsTwo[1].describe;
         this.$forceUpdate();
     },
     closePage(){
         var that = this;
          var notice = $('#purpleFun').offset();
     $('#halloweenSaled').animate({
    		left:notice.left+22,
    		top:notice.top+12,
    		marginLeft:0,
    		marginTop:0,
    		height:0,
			width:0
		  },1300);
           let t = setTimeout(function () {
                that.halloweenSaleShow = false;
                if(that.notifyShow){
                   //自动打开通知弹窗
                  that.notifyShow =false;
                  commonUtils.getNotifications(that.$parent.$refs.rightContBan);
                  that.$parent.$refs.rightContBan.newNotifyShow=true; 
                  return;     
                }
                if(that.$parent.$refs.rightContBan.letTimeSalePassWordShow){
                    that.$parent.$refs.rightContBan.letTimeSalePassWordShow= false;
                    that.$parent.$refs.rightContBan.showPassWord();
                }
                clearTimeout(t);
            }, 1200);
     },
     upgrade(item){
         var that = this;
         let lang = commonUtils.getLocaleTo(localStorage.getItem("locale"));
         commonUtils.refreshUserInfo(that, function (res) {
             that.user = res;
             //检测用户是否绑定邮箱，如果未绑定邮箱则打开绑定邮箱界面
        if (!commonstate.emailpattern.test(that.user.email)) {
         // that.sendGAEvent(item);
          paySysUtils.openBindEmailPage(that.$parent.$refs.rightContBan,item,"halloween");
          return false;
        }
         that.getUserStatus(); //开始检测用户的状态
         //如果用户想购买有限月
        if(item.productId == '215655'){
           that.Utils.doUserHaveLoginRequest('getUpShellActiveTime', {
            ud: that.user.id,
            salt: that.user.salt
        }).then(response => {
          var upShellActiveTime = response.upShellActiveTime;
          // let key = 'monthLyActive' + that.user.id; //计算时间差是否超过了24小时
          let firstTime = upShellActiveTime; //首次点击页面时间
          let nowDateStr = commonUtils.getNowDateFormat();
          let dateTime = nowDateStr.replace(new RegExp("-", "gm"), "/");
          let nowDateLong = new Date(dateTime).getTime(); //现在时间
          let timeDiff;
          let downTime; //倒计时时间
           if(firstTime){//如果存在第一次点击时间
                timeDiff = nowDateLong - firstTime;
                if (timeDiff > 86400000) { //如果超过了24小时
              // 取得要提交页面的URL
            //   googleAnalyticsUtil.pay2(that, "monthly2");
                 var action = commonstate.cbLinkUrl + '/1533/purl-mc-cart?x-linkid=' + lang + '';
                 commonUtils.packageFormAndSubmit(action, item, that.user);
                } else { //进入倒计时界面
            //   googleAnalyticsUtil.pay2(that, "monthly2-0");
              downTime = 86400 - parseInt((new Date(dateTime).getTime() - firstTime) / 1000);
              let link = '/monthly-unlimited-web.html?id=' + that.user.id + '&time=' + downTime + '&lang=' +
                lang + '&page=monthly1';
              let language = commonUtils.getLocaleToIndex(that.$i18n.locale);
              if (language != 'en') {
                window.open(commonstate.frontEndUrl + '/' + language + link, '_blank');
              } else {
                window.open(commonstate.frontEndUrl + link, '_blank');
              }
            }
           }else{
              //  localStorage.setItem(key, nowDateLong);
               //把值存入数据库
              let changeData = {
              ud: that.user.id,
              upShellActiveTime: nowDateLong,
            }
              that.Utils.doUserHaveLoginRequest("saveUpShellActiveTime", changeData).then(res => { });
              let link = '/monthly-unlimited-web.html?id=' + that.user.id + '&time=' + 86400 + '&lang=' + lang +
              '&page=monthly1';
            let language = commonUtils.getLocaleToIndex(that.$i18n.locale);
            if (language != 'en') {
              window.open(commonstate.frontEndUrl + '/' + language + link, '_blank');
            } else {
              window.open(commonstate.frontEndUrl + link, '_blank');
            }
           }
            commonUtils.refreshUserInfo(that, function (res) { });
            });
        }else{
        //用户是vip并且用户想升级无限年
        if(that.user.vip && item.productId == '236257'){
           item.loading = true;
           that.getItemSubScrition(item);
           return;
        }
        // 取得要提交页面的URL
        var action =commonstate.cbLinkUrl+'/1533/purl-mc-cart?x-linkid='+lang+'';
        commonUtils.packageFormAndSubmit(action,item,that.user);
        }
           });
     },
     getUserStatus () { ///通过获取最新的User判断user是否已经状态改变，如果状态改变则刷新界面
      let oldUser = this.user;
      let that = this;
      let newUser;
      let oldPassword;
      let t;
      this.Utils.doUserHaveLoginRequest('get', {
        ud: oldUser.id,
        salt: oldUser.salt
      }).then(response => {
        that.requestNum = that.requestNum + 1;
        newUser = response.user;
        if (!oldUser.password) {
          delete newUser.password;
        } else {
          oldPassword = oldUser.password;
        }
        that.$store.commit('setPassWord', response.user.password);
        var result = commonUtils.Compare(oldUser, newUser);
        if (that.requestNum == 80) { //如果请求了50次则取消请求
          clearTimeout(t);
          return false;
        }
        if (result != false || !newUser.vip) { //如果结果是相等则过2秒再进行请求
          t = setTimeout(() => {
            that.getUserStatus();
          }, 2500);
        } else { //如果用户状态已改变
          clearTimeout(t);
          if (oldPassword) {
            newUser.password = oldPassword;
          } else {
            delete newUser.password;
          }
           localStorage.setItem("user", JSON.stringify(newUser));
           that.$cookies.set("user",JSON.stringify(newUser),"7d");
          if(newUser.vip && newUser.payType != 'Lifetime' && newUser.payType != 'Yearly'){//如果购买的是月
               upgradeItemUtils.getItemPreview(null,function(res){
               upgradeItemUtils.getItemPreview('halloween',function(result){
                 that.user = newUser;
                 that.initData();
                 that.$forceUpdate();
                   if(that.$route.name == 'paySys'){
                     const vm = window.vm.$children[0].$refs.routerView.$refs.routView;
                     vm.initShowData();
                     }
               });
            });
          }else{
             if(that.$parent.$refs.payDiffDialog.diffShow){
               that.$parent.$refs.payDiffDialog.loading = false;
               that.$parent.$refs.payDiffDialog.diffShow=false;
              }
              that.user = newUser;
              that.initData();
          }
          if(that.$route.name == 'paySys'){
             const vm = window.vm.$children[0].$refs.routerView.$refs.routView;
             vm.initShowData();
          }
          // 付费升级全局缓存标记
          that.$store.commit("setPayUpgrade", true);
          that.$store.state.halloweenPayUpgrade = true;
          if (that.$parent && that.$parent.$refs.rightContBan) {
            //关闭限时购买弹窗后再出现通知信息
            that.$parent.$refs.rightContBan.email = newUser.email;
            that.$parent.$refs.rightContBan.usedTraffic = newUser.usedBytes;
            // if (newUser.vip && newUser.payLevel > 1) {
            //   that.$parent.$refs.rightContBan.usedTraffic = newUser.payUsedTraffic;
            // }
            that.$parent.$refs.rightContBan.totalTraffic = newUser.totalBytes;
            commonUtils.createPayBtn(newUser, that.$parent.$refs.rightContBan);
          }
          if (newUser.payLevel <= 1) {
            if (newUser.payType == 'Lifetime') {
              that.$parent.$refs.rightContBan.funnelShow = false; //不显示漏斗
              that.closePage();
              that.$parent.$refs.leftBanner.menuOptionSelect(10);
              that.$router.push({
                name: "addCloud"
              });
            }
          }
        }
      });
    },
    //获取用户的订阅
    getItemSubScrition (item) {
      this.sendSubScribeRequest = false;
      var payDiffDialog = this.$parent.$refs.payDiffDialog;
      var subId = this.user.subscrId
      if(this.user.subscrId.indexOf('-')>0){
          subId = this.user.subscrId.slice(0, this.user.subscrId.indexOf('-'));
      }
      payDiffDialog.payInfo.subId = subId;
      payDiffDialog.source='halloween';
      this.$nextTick(()=>{
       payDiffDialog.updateItemPreview();
      });
      var self = this;
      this.Utils.doCbSubscriptionPostRequest('get_by_id', { subscriptionId: subId }).then(res => {
        //如果请求成功
        // item.loading = false;
        if (res.ResultMessage == 'OK') {
          let paymentInfo = res.Subscription.PaymentInfo;
          let purchaseId = res.Subscription.Items[0].SubscriptionPurchaseItems[0].PurchaseId;
          payDiffDialog.payInfo.purchaseId = purchaseId;
          payDiffDialog.payInfo.subId = subId;
          payDiffDialog.getChangeUrl();
          if (paymentInfo != null) {
            payDiffDialog.payInfo.payMethod = paymentInfo.PaymentType;
            payDiffDialog.payInfo.lastFourNumber = paymentInfo.CardLastFourDigits;
          } else {
            self.getPurchaseV1(purchaseId);
          }

        }
      });
    },
    getPurchaseV1 (purchaseId) {
      var self = this;
       var payDiffDialog = this.$parent.$refs.payDiffDialog;
      this.Utils.doCbSubscriptionPostRequest('get_by_purchaseId', { purchaseId: purchaseId }).then(res => {
        //如果请求成功
        if (res.ResultMessage == 'OK') {
          if (res.Purchase.PaidOrderNotification.Purchase.PaymentInfo != null) {
            let paymentInfo = res.Purchase.PaidOrderNotification.Purchase.PaymentInfo;
            payDiffDialog.payInfo.payMethod = paymentInfo.PaymentType;
          }
        }
      });
    },
 }
}
</script>

<style>
#halloweenSaled{
    
     box-sizing: border-box;
     padding: 10Px;
}
.halloweenSaled_one{
     width: 1050Px;
     height: 530Px;
}
.halloweenSaled_two{
    width: 844Px;
     height: 530Px;
}
.halloweenSaled_three{
    width: 490Px;
     height: 530Px;
}
.halloweenSaled_position{
    float: right;
    cursor: pointer;
}
.halloweenSaled_title{
   width: 100%;
   height: 55Px;
   display: flex;
   align-items: center;
   text-align: center;
   vertical-align: middle;
}
.halloweenSaled_product{
    width: 100%;
    height: 310Px;
    display: flex;
    align-items: center;
    text-align: center;
    vertical-align: middle;
}
.product_one{
    width: 250Px;
    height: 315Px;
    background: #fff;
    border-radius: 20Px;
    margin: 0 auto;
  
}
.product_img{
   width: 100%;
   display: flex;
     align-items: center;
    text-align: center;
    vertical-align: middle;
    height: 120Px;
}
.product_descri_all .el-loading-spinner .circular {
  height: 0.25rem !important;
  width: 0.25rem !important;
  position: relative;
  top: 30Px;
}

.product_descri_all .el-loading-mask {

  background-color: #e61c1c !important;
  border-radius: 10Px;
  z-index: 10 !important;
}

.product_descri_all .el-loading-spinner .path {
  stroke: #ffffff !important;
}
.product_all{
    width: 925Px;
    height: 315Px;
    margin: 0 auto;
      display: flex;
    align-items: center;
    text-align: center;
    vertical-align: middle;
}
.product_two{
    width: 615Px;
    height: 315Px;
    margin: 0 auto;
      display: flex;
    align-items: center;
    text-align: center;
    vertical-align: middle;
}
.product_name{
    margin-top: 26Px;
    font-size: 18Px;
    color: #201441;
    font-weight: bold;
}
.product-txt{
   font-size: 22Px;
   color: #fff;
   position: relative;
   top: 35Px;
   font-weight: bold;
}
.product_descri{
    color: #ababac;
    width: 200Px;
    font-size: 12Px;
    margin: 0 auto;
    line-height: 18Px;
}
.product_descri_all{
    width: 100%;
    display: flex;
     align-items: center;
    text-align: center;
    vertical-align: middle;
}
.product_price{
    font-size: 20Px;
    color: #201441;
     margin: 0 auto;
     font-weight: bold;
    float: left;
}
.product_oldprice{
     font-size: 14Px;
    color: #a1a0a3;
     margin: 0 auto;
   float: left;
   margin-left: 10Px;
   position: relative;
   top: 5Px;
   text-decoration: line-through;
}
.product_button{
    font-size: 12Px;
    border: 1Px solid #e61c1c;
    border-radius: 10Px;
    width: 150Px;
    height: 32Px;
     margin: 0 auto;
     color: #e61c1c;
     line-height: 32Px;
     font-weight: bold;
      cursor: pointer;
}
.product_button_other{
     font-size: 12Px;
    border: 1Px solid #e61c1c;
    border-radius: 10Px;
    width: 150Px;
    height: 32Px;
     margin: 0 auto;
     color: #fff;
     line-height: 32Px;
     font-weight: bold;
     background: #e61c1c;
     cursor: pointer;
}

.blackFriday-price-btn {
  position: relative;
  margin: auto;
  width: 150px; /*no*/
  height: 34px; /*no*/
  border: 1px solid #e61c1c; /*no*/
  border-radius: 10px; /*no*/
  font-size: 12px; /*no*/
  line-height: 34px; /*no*/
  font-weight: bold;
  cursor: pointer;
}
.blackFriday-price-btn:hover {
  background: #ea3a22;
  color: #ffffff;
}

.blackFriday-price-btn-2 {
  background: #ffffff;
  color: #e61c1c;
}
.blackFriday-price-btn-1 {
  background: #e61c1c;
  color: #ffffff;
}

.blackFriday-discount1 .product-txt {
    padding-left: 15px;/*no*/
}

.blackFriday-discount2 .product-txt {
    padding-right: 15px;/*no*/
}

.blackFridaySaled_one{
     width: 1050Px;/*no*/
     height: 530Px;/*no*/
}
.blackFridaySaled_two{
    width: 844Px;/*no*/
     height: 530Px;/*no*/
}
.blackFridaySaled_three{
    width: 490Px;/*no*/
     height: 530Px;/*no*/
}
.blackFridaySaled_position{
    float: right;
    cursor: pointer;
}
.blackFridaySaled_title{
   width: 100%;
   height: 55Px;/*no*/
   display: contents;
   align-items: center;
   text-align: center;
   vertical-align: middle;
}
.blackFridaySaled_product{
    width: 100%;
    height: 310Px;/*no*/
    display: flex;
    align-items: center;
    text-align: center;
    vertical-align: middle;
}

.blackFriday-last-tip{
  position: absolute;
  top: 130px;/*no*/
  left: 46%;/*no*/
  width: 208px;/*no*/
  height: 40px;/*no*/
  text-align: left;
  font-family: "MM Extreme";
  font-weight: 400;
  color: rgb(230, 207, 161);
  background-color: rgb(194, 27, 22);
  line-height: 20px;/*no*/
  border-radius: 10px;/*no*/
  display: table;
}

.blackFriday-last-tip span{
  display: table-cell;
  vertical-align: middle;
}
.blackFridaySaled_two .blackFriday-last-tip{
  left: 45%;/*no*/
}
</style>


// WEBPACK FOOTER //
// src/components/popup/upgrade_popups/limited_halloween_saled_popup.vue